import { render, staticRenderFns } from "./BusinessTypeMenu.vue?vue&type=template&id=3ffb5efd&scoped=true&"
import script from "./BusinessTypeMenu.vue?vue&type=script&lang=js&"
export * from "./BusinessTypeMenu.vue?vue&type=script&lang=js&"
import style0 from "./BusinessTypeMenu.vue?vue&type=style&index=0&id=3ffb5efd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb5efd",
  null
  
)

export default component.exports